import { render } from "./ClearItem.vue?vue&type=template&id=38a22794"
import script from "./ClearItem.vue?vue&type=script&lang=js"
export * from "./ClearItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__